export const DEFAULT_BRANCH = '+:<default>'
export const ALL_BRANCHES = '+:*'
